<template>
    <div>
        <h1 style="font-size: 24px; color: black;">DogFlag</h1>
        <el-row>
            <el-col>
                <el-button type="primary" @click="showSaveFormDialog('新增')">新增</el-button>
            </el-col>
        </el-row>
        <el-button type="primary" @click="getList">查询</el-button>
        <h1>
            <el-table border :data="list">
              <el-table-column prop="id" label="编号" align="center"></el-table-column>
              <el-table-column prop="flagOn" label="上报概率" align="center"></el-table-column>
                <el-table-column prop="flagOff" label="不上报概率" align="center"></el-table-column>
                <el-table-column prop="flagTime" label="停留时间" align="center"></el-table-column> <!-- 停留时间,单位为秒 -->
              <el-table-column prop="umengFlag" label="友盟上报(A扣量 B不扣量)" align="center"></el-table-column> <!-- 停留时间,单位为秒 -->

              <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px">
            <el-form :model="saveForm">
                <el-form-item label="上报概率" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.flagOn"></el-input>
                </el-form-item>
                <el-form-item label="不上报概率" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.flagOff"></el-input>
                </el-form-item>
              <el-form-item label="时间（秒）" :label-width="labelWidth">
                <el-input type="text" v-model="saveForm.flagTime"></el-input>
              </el-form-item>

              <el-form-item label="友盟上报(A扣量 B不扣量)" :label-width="labelWidth">
                <el-input type="text" v-model="saveForm.umengFlag"></el-input>
              </el-form-item>

            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import app from "@/App.vue";
import {removeFlag, saveFlag, searchFlag} from "@/http/dogApi";

export default {
    name: "DogFlag",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            list: [],
            saveForm: {
              id: null,
                flagOn: null,
                flagOff: null,
                flagTime: null,
                umengFlag:null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
        }
    },
    methods: {
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchFlag(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeFlag(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
              id: null,
                flagOn: null,
                flagOff: null,
                flagTime: null,
                umengFlag:null
            };
            if (_data) {
                this.saveForm = {
                  id: _data.id,
                  flagOn: _data.flagOn,
                    flagOff: _data.flagOff,
                    flagTime: _data.flagTime,
                  umengFlag: _data.umengFlag

                }
            }
        },
        confirmForm() {
            saveFlag(this.saveForm).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
    }
}
</script>

<style scoped>

</style>
